import { Form, Input } from "antd";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { retrieveBankAccDetails } from "../../redux/actions/bankAccActions";
import { RootState } from "../../redux/rootReducer";
import { Actions } from "../../shared/constant";

function BankDetailsForm({
  mode,
  editData,
  bankForm,
}: {
  mode: string;
  editData: any;
  bankForm: any;
}) {
  const dispatch = useDispatch();
  const { bankDetails } = useSelector((state: RootState) => state.bankAcc);

  useEffect(() => {
    if (mode === Actions.EDIT) {
      // Two apis available
      dispatch(retrieveBankAccDetails({ clientId: editData.id }));
    }
  }, [mode]);

  useEffect(() => {
    if (bankDetails && mode === Actions.EDIT) {
      bankForm.setFieldsValue({
        account_name: bankDetails.account_name,
        account_no: bankDetails.account_no,
        bank_name: bankDetails.bank_name,
        branch: bankDetails.branch,
        routing_no: bankDetails.routing_no,
        phone: bankDetails.phone,
      });
    }
  }, [bankDetails]);

  return (
    <div className="mb-[14px]">
      <div className="grid grid-cols-2 gap-x-6">
        <Form.Item name="account_name" label="Account Name">
          <Input />
        </Form.Item>
        <Form.Item name="account_no" label="Account No">
          <Input />
        </Form.Item>
        <Form.Item name="bank_name" label="Bank">
          <Input />
        </Form.Item>
        <Form.Item name="branch" label="Branch">
          <Input />
        </Form.Item>
      </div>
      <div className="btn-border pt-2" />
      <div className="grid grid-cols-2 gap-x-6 mt-3.5">
        <Form.Item name="routing_no" label="Routing Number">
          <Input />
        </Form.Item>
        <Form.Item name="phone" label="Phone Number">
          <Input />
        </Form.Item>
      </div>
    </div>
  );
}

export default BankDetailsForm;
